/**
 * AON CRAFT TOOLKIT LOGIN
 *
 */

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

import './lib/foundation-explicit-pieces';

//$(document).foundation();
$( '.language-menu-icon, #language_menu' ).foundation();


$(document).ready( function () {
	$( '#language_menu_container' ).show();
    if ( $( '#loginform' ).length > 0 ) {
	   $( '#user_pass' ).attr( 'autocomplete', 'off' );
    }
});

/*
// Language Selector
$( 'body' ).on( 'click', '.language_selector input[type="radio"]', function( event ) {
	console.log( 'Language clicked: ' + $( this ).val() );
	var lang_save = $( this ).val();
	if ( lang_save == '' ) {
		lang_save = 'Save';
	}
	$( '.language_selector input[type="submit"]' ).val( $( '.lang_save_' + lang_save ).val() );
	//event.preventDefault();
});
*/
